import React, { useState } from "react";
import TabcordionVideoModal from "./TabcordionVideoModal";
import ButtonIcon from "components/utility/button/ButtonIcon";
const TabcordionVideo = ({ vid, image, alt }) => {
	const [showModal, setShowModal] = useState(false);

	const openModal = () => {
		setShowModal((prev) => !prev);
	};

	return (
		<div className="tabcordion--card">
			<button className="tabcordion--card-btn" onClick={openModal}>
				<div className="tabcordion--card-container">
					<img className="tabcordion--card-image" src={image} alt={alt} />
					<div className="tabcordion--card-overlay"></div>
					<div className="content-card-button">
						<ButtonIcon type="play" color="teal" />
					</div>
				</div>
			</button>
			<TabcordionVideoModal showModal={showModal} setShowModal={setShowModal} vid={vid} />
		</div>
	);
};

export default TabcordionVideo;
